export default __webpack_public_path__ + "static/media/ribbonRedOutlined.36f99748.svg";